import Spinner from '../common/Spinner';

const CustomSpinner = () => {
  return <Spinner className="mt-52 size-10 self-center w-full" />;
};

export default CustomSpinner;
